import { RightOutlined } from '@ant-design/icons';

import { PortalRouterMatch } from '@willow/types-iso';

import { MULTI_BODY, MULTI_TITLE, USE_DIFFERENT_EMAIL } from './findPortalCopy';
import { FindPortalLayout } from './FindPortalLayout';
import { FindPortalLinkButton } from './FindPortalLinkButton';
import { LenderRow } from './LenderRow';

import s from './FindPortal.module.scss';

interface Props {
  matches: PortalRouterMatch[];
  onSelect: (match: PortalRouterMatch) => void;
  onUseDifferentEmail: () => void;
}

export const MultiMatchScreen = ({ matches, onSelect, onUseDifferentEmail }: Props) => (
  <FindPortalLayout
    testId="find-portal-screen-multi"
    documentTitle={MULTI_TITLE}
    title={MULTI_TITLE}
    description={MULTI_BODY}
  >
    <div className={s.lenderList}>
      {matches.map((match, index) => (
        <button
          key={match.loginUrl}
          type="button"
          className={s.lenderButton}
          data-testid={`find-portal-lender-${index}`}
          onClick={() => onSelect(match)}
        >
          <LenderRow match={match} />
          <RightOutlined className={s.chevron} />
        </button>
      ))}
    </div>
    <FindPortalLinkButton data-testid="find-portal-use-different-email" onClick={onUseDifferentEmail}>
      {USE_DIFFERENT_EMAIL}
    </FindPortalLinkButton>
  </FindPortalLayout>
);
